export default __webpack_public_path__ + "static/media/ig.1912cd98.svg";